import { StudentInternShipKeyDetails } from "./student-internship-key-details-model";

export class StudentAv{
    subtitle = 'Student Availability Details';
    showLabels=['Available for internship?','4th semester exam start','4th semester exam end','Summer Vacation start','Summer Vacation end','Internship start','Internship end','Remarks (if any)']
    keyLabels= ['isInternshipAssigned','studentExamStartDate','studentExamEndDate','studentSummerVacationStartDate','studentSummerVacationEndDate','studentExpectedInternshipStartDate','studentExpectedInternshipEndDate','studentAvailabilityRemark']
    keyDetails:StudentInternShipKeyDetails[]= []
}